import { useState, useEffect } from "react";
import { Row, Col, Tabs, Dropdown, Menu } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  MoreOutlined,
} from "@ant-design/icons";

import DataTable from "../../DataTable";

const { TabPane } = Tabs;

interface IProductProps {
  products: any;
  showEditModal: Function;
  handleDelete: Function;
  filtered: any;
}

const FuneralProductTable: React.FC<IProductProps> = ({
  products,
  showEditModal,
  handleDelete,
  filtered,
}) => {
  const [active, setActive] = useState([]); //All Tab
  const [inactive, setInactive] = useState([]); //Cancelled Tab

  const [filteredActive, setFilteredActive] = useState([]); //Active Tab
  const [filteredInActive, setFilteredInActive] = useState([]); //Active Tab

  const [state, setState] = useState({
    loading: true,
    activeKey: sessionStorage.getItem("funeralProductsActiveTab") || "1",
    pagination: {
      pageSize: 15,
      position: ["bottomRight"],
      total: 0,
      current: Number(sessionStorage.getItem("funeralProductsPage")) || 1,
      hideOnSinglePage: true,
    },
    searchItem: "",
  });

  const fetchActive = async (params = {}) => {
    try {
      const active = products.filter(
        (item: any) => item.Status.Status === "Active"
      );

      if (filtered.length > 0) {
        const activeFiltered = filtered.filter(
          (item: any) => item.Status.Status === "Active"
        );
        setFilteredActive(activeFiltered);
      }

      const pagination = state.pagination;
      pagination.total = filtered.length.toString();

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });

      setActive(active);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchInActive = async (params = {}) => {
    try {
      const inactive = products.filter(
        (item: any) => item.Status.Status === "Inactive"
      );

      if (filtered.length > 0) {
        const inActiveFiltered = filtered.filter(
          (item: any) => item.Status.Status === "Inactive"
        );
        setFilteredInActive(inActiveFiltered);
      }

      const pagination = state.pagination;
      pagination.total = filtered.length.toString();

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });
      setInactive(inactive);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchActive();
    fetchInActive();
  }, [products, filtered]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    const pager = { ...state.pagination };
    pager.current = pagination.current;
    sessionStorage.setItem("funeralProductsPage", String(pagination.current));
    setState({
      ...state,
      pagination: pager,
    });

    const params = {
      pageSize: pagination.pageSize,
      page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    };

    fetchActive(params);
  };

  const columns = [
    {
      title: "Product ID",
      dataIndex: "id",
      sorter: (a: any, b: any) => a.id.localeCompare(b.id),
    },
    {
      title: "Product Code",
      dataIndex: "Code",
      sorter: (a: any, b: any) => a.Code.localeCompare(b.Code),
    },
    {
      title: "Product Name",
      dataIndex: "Name",
      sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Product Description",
      dataIndex: "Description",
    },
    {
      title: "Product Price",
      dataIndex: "Price",
    },
    {
      dataIndex: "Action",
      render: (_: any, record: any) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="edit"
                icon={<EditOutlined style={{ color: "blue" }} />}
                onClick={() => showEditModal(record)}
              >
                Edit Product
              </Menu.Item>
              <Menu.Item
                key="remove"
                icon={<DeleteOutlined style={{ color: "red" }} />}
                onClick={() => handleDelete(record.id, state.activeKey)}
              >
                Remove Product
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <MoreOutlined
            rotate={90}
            style={{ cursor: "pointer", fontSize: "16px", color: "#000" }}
          />
        </Dropdown>
      ),
    },
  ];

  const tabPanes = [
    {
      key: "1",
      title: "Active",
      content: (
        <DataTable
          persistKey="funeral-products"
          dataSource={filteredActive.length > 0 ? filteredActive : active}
          columns={columns}
          loading={state.loading}
          pagination={state.pagination}
          onChange={handleTableChange}
        />
      ),
      count: filteredActive.length > 0 ? filteredActive.length : active.length,
    },
    {
      key: "2",
      title: "Inactive",
      content: (
        <DataTable
          persistKey="funeral-products"
          dataSource={filteredInActive.length > 0 ? filteredInActive : inactive}
          columns={columns}
          loading={state.loading}
          pagination={state.pagination}
          onChange={handleTableChange}
        />
      ),
      count:
        filteredInActive.length > 0 ? filteredInActive.length : inactive.length,
    },
  ];

  const changeTab = (key: any) => {
    const pagination = { ...state.pagination, current: 1 };
    sessionStorage.setItem("funeralProductsActiveTab", key);
    sessionStorage.setItem("funeralProductsPage", "1");
    setState({
      ...state,
      activeKey: key,
      loading: false,
      pagination,
    });
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Tabs
            type="card"
            defaultActiveKey={state.activeKey}
            activeKey={state.activeKey}
            onChange={changeTab}
          >
            {tabPanes.map((pane) => (
              <TabPane
                key={pane.key}
                tab={
                  <>
                    <span>{pane.title}</span>
                    <span
                      style={{
                        color: "#B0B0B0",
                        fontWeight: "300",
                        marginLeft: "3px",
                        fontSize: "12px",
                      }}
                    >
                      ({pane.count})
                    </span>
                  </>
                }
              >
                {pane.content}
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default FuneralProductTable;
